module.exports = __webpack_public_path__ + "assets/img/layer.22c46bcf.png";